module.exports = __webpack_public_path__ + "static/media/cog-ic.7ba60257.svg";